export default "__VITE_ASSET__DPinN2LU__"